<xux-dashboard-layout
  [layoutOptions]="layoutOptions"
  [dashboardLayoutCells]="dashboardCells"
></xux-dashboard-layout>
<ng-template #XuxDndItemTemplate let-item="item">
  <xux-dnd-item
    [itemData]="item.itemConfig"
    [dndConfig]="dndConfig"
    (remove)="removeItem(item)"
    [ngClass]="item.class"
  ></xux-dnd-item>
</ng-template>
